module.exports = __webpack_public_path__ + "img/konto-img.c06e437b.png";